import { useLoadScript } from '@react-google-maps/api';
import { Alert, AlertDescription } from "@/components/ui/alert";
import { Loader2 } from "lucide-react";

// Optimize by only loading required libraries
const libraries = ["places"] as const;

interface MapWrapperProps {
  children: React.ReactNode;
}

export default function MapWrapper({ children }: MapWrapperProps) {
  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY || '',
    libraries,
  });

  if (loadError) {
    return (
      <Alert variant="destructive">
        <AlertDescription>
          Failed to load Google Maps. Please check your internet connection and try again.
        </AlertDescription>
      </Alert>
    );
  }

  if (!isLoaded) {
    return (
      <div className="w-full h-[300px] flex items-center justify-center bg-gray-50 rounded-lg">
        <Loader2 className="h-8 w-8 animate-spin text-gray-500" />
      </div>
    );
  }

  return <>{children}</>;
}